import { Currency } from './enums';

/**
 * Allowance for free tier in credits.
 */
export const FREE_TIER_CREDIT_ALLOWANCE = 10;

/**
 * Rates for converting credits (currency we use internally to track
 * all usage, funnily it is equal to 1 USD) to other currencies.
 */
export const CreditCurrencyRates = Object.freeze({
  [Currency.USD]: 1,
  [Currency.CZK]: 23,
});
